import React from "react";
import { motion } from "framer-motion";

const AnimationWrapper = ({ children, animationKey }) => {
  return (
    <motion.div
      key={animationKey}
      initial={{ opacity: 0.9, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 10 }}
      transition={{ duration: 0.3 }}
    >
      {children}
    </motion.div>
  );
};

export default AnimationWrapper;
